/**
 * Step 4: プレビューステップ
 *
 * 名前とアイコンを2つのデザインで確認表示
 * - 左: UserBtn風（プレイ画面）
 * - 右: UserPage風（プロフィール画面）
 * ボタンは親コンポーネント（CreateUserWizard）のフッターで管理
 */
import I18n from "common/i18n";
import { CreateUserState, UserType } from "../types";

interface PreviewStepProps {
  state: CreateUserState;
  updateState: (updates: Partial<CreateUserState>) => void;
  userType: UserType;
}

export const PreviewStep = ({ state }: PreviewStepProps) => {
  return (
    <div className="flex-col-el flex-center w-full h-full">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[32px]">
          {I18n.t("MSG_CREATE_USER_TITLE_PREVIEW")}
        </p>
      </div>

      {/* プレビュー横並び */}
      <div className="flex-row-el flex-center gap-16">
        {/* 左: UserBtn風（プレイ画面）- 完全照抄 */}
        <div className="flex-col-center">
          <div
            className="flex-col-el flex-center cursor-pointer bg-white rounded-full z-10 relative"
            style={{
              width: 104,
              height: 104,
              filter: "drop-shadow(1px 1px 2px rgba(63, 74, 97, 0.4))",
            }}
          >
            <div className="flex-col-center w-[85%] h-[85%] rounded-full overflow-hidden">
              {state.icon ? (
                <img
                  src={state.icon}
                  alt="プレイヤープロフィール画像"
                  className="w-full h-full object-contain"
                />
              ) : (
                <span className="material-symbols-outlined text-[60px] text-gray-40">person</span>
              )}
            </div>

            <div
              className="flex-col-el flex-center absolute -bottom-3 w-[110px] h-[30px] px-2 bg-beige-10 rounded-[32px] text-textcolor-black"
              style={{
                boxShadow:
                  "-1px 1px 1px rgba(63, 74, 97, 0.15), 1px 1px 3px rgba(63, 74, 97, 0.25)",
              }}
            >
              <p className="text-body text-center text-base text-body-ellipsis w-full">
                {state.name}
              </p>
            </div>
          </div>
        </div>

        {/* 右: UserPage風（プロフィール画面）- 完全照抄 */}
        <div className="flex-col-center">
          <div
            style={{
              boxShadow: "-1px 1px 1px rgba(63, 74, 97, 0.15), 1px 1px 3px rgba(63, 74, 97, 0.25)",
            }}
            className="flex-col-center bg-white rounded-full mb-2 w-[160px] h-[160px] relative"
          >
            <div className="flex-col-center w-[85%] h-[85%] rounded-full overflow-hidden">
              {state.icon ? (
                <img
                  src={state.icon}
                  alt="プレイヤープロフィール画像"
                  className="w-full h-full object-contain"
                />
              ) : (
                <span className="material-symbols-outlined text-[80px] text-gray-40">person</span>
              )}
            </div>
          </div>

          <div
            className="flex-col-center w-[250px] h-[40px] bg-beige-10 rounded-[32px] text-textcolor-black mt-[-20px]"
            style={{
              boxShadow: "-1px 1px 1px rgba(63, 74, 97, 0.15), 1px 1px 3px rgba(63, 74, 97, 0.25)",
            }}
          >
            <p className="text">{state.name}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
